import { render } from "./ChurchSetUp.vue?vue&type=template&id=e8e2afd0&scoped=true"
import script from "./ChurchSetUp.vue?vue&type=script&lang=js"
export * from "./ChurchSetUp.vue?vue&type=script&lang=js"

import "./ChurchSetUp.vue?vue&type=style&index=0&id=e8e2afd0&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8e2afd0"]])

export default __exports__